import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'
import FormInput from './FormInput'

function TableRow({
  data,
  mod,
  filters,
  cart,
  handleCart,
  active,
  currentCategory,
  subCategory = null,
}) {
  const {
    areaFilter,
    filterBrand,
    filterThickness,
    filterTexture,
    filterPlaster,
    typeFinishLayer,
  } = filters || {}
  const { id, name, unit, price, consumption, packing, in_stock, category_id, brand, section } =
    data || {}
  const pricePerVolume = +(price / (packing / consumption)).toFixed(2)

  let count = 0
  if (currentCategory == 5 && subCategory == 2) {
    count = Math.ceil((areaFilter / packing) * 1.1)
  } else if (currentCategory == 3) count = Math.ceil(areaFilter / packing)
  else count = Math.ceil((areaFilter * consumption) / packing)

  const [countProduct, setCountProduct] = useState(count)
  const [totalPrice, setTotalPrice] = useState(+(count * price).toFixed(2) || 0)

  useEffect(() => {
    if (mod != 'header') {
      setCountProduct(count)
      setTotalPrice(+(count * price).toFixed(2) || 0)
    }
  }, [areaFilter, filterBrand, filterThickness, filterTexture, filterPlaster, typeFinishLayer])

  const addToCart = () => {
    const cartProduct = {
      id,
      brand: brand || null,
      subCategory: section || null,
      name,
      unit,
      consumption,
      priceProduct: price,
      in_stock,
      category_id,
      totalPrice: totalPrice,
      count: countProduct,
    }
    handleCart([...cart, cartProduct])
  }

  const removeFromCart = () => {
    let newCart = [...cart]
    const pos = newCart.findIndex(el => el.id == id && el.category_id == currentCategory)
    if (pos != -1) {
      newCart.splice(pos, 1)
      handleCart(newCart)
    }
  }

  const handleCountProduct = async e => {
    setCountProduct(Math.ceil(e))
    setTotalPrice(+(e * price).toFixed(2))
    removeFromCart()
  }

  return (
    <Row type={mod} active={active}>
      {mod && mod == 'header' ? (
        <>
          <Row.Cell>Наименование {currentCategory}</Row.Cell>
          <Row.Cell>Фасовка</Row.Cell>
          <Row.Cell>Цена, BYN</Row.Cell>
          <Row.Cell>Цена за м. кв, BYN</Row.Cell>
          <Row.Cell>
            Кол-во{' '}
            <div className="helpers">
              ?
              <div className="tooltip">
                Данные в колонке «Кол-во» рассчитаны исходя из среднего расхода на м. кв.
                <br /> <br />
                Вы можете изменить кол-во на необходимое Вам.
              </div>
            </div>
          </Row.Cell>
          <Row.Cell>Сумма</Row.Cell>
          <Row.Cell>Выбор</Row.Cell>
          <Row.Cell>Наличие</Row.Cell>
        </>
      ) : (
        <>
          <Row.Cell>{name}</Row.Cell>
          <Row.Cell>{packing + ' ' + unit}</Row.Cell>
          <Row.Cell>{price}</Row.Cell>
          <Row.Cell>{pricePerVolume}</Row.Cell>
          <Row.Cell>
            <>
              {areaFilter ? (
                <div>
                  <FormInput
                    type="NumberMask"
                    mod={'count'}
                    value={'' + countProduct}
                    onChange={handleCountProduct}
                  />
                </div>
              ) : (
                'Введите площадь утепления'
              )}
            </>
          </Row.Cell>
          <Row.Cell>{totalPrice} byn</Row.Cell>
          <Row.Cell
            onClick={!active ? addToCart : removeFromCart}
            button
            disabled={!countProduct || !totalPrice}
          >
            <Checkbox active={active} />
          </Row.Cell>
          <Row.Cell>{in_stock}</Row.Cell>
        </>
      )}
    </Row>
  )
}

export default TableRow

const Checkbox = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    border: 1px solid #b8b8b8;
    border-radius: 2px;
    transition: 0.3s;
  }

  &:after {
    content: '';
    position: absolute;
    transform: translate(-50%, -50%) scale(0) rotate(-35deg);
    opacity: 0;
    width: 9px;
    height: 5px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #ffff;
    opacity: 0;
    left: 50%;
    top: calc(50% - 1px);
    transition: 0.3s;
  }

  ${p =>
    p.active &&
    css`
      &:before {
        border-color: #3b99fc;
        background: #3b99fc;
      }

      &:after {
        transform: translate(-50%, -50%) scale(1) rotate(-35deg);
        opacity: 1;
      }
    `}
`
const Row = styled.div`
  display: table-row;

  &:hover {
    background: rgba(255, 213, 76, 0.3);
  }

  ${p =>
    p.active &&
    css`
      background: rgba(255, 213, 76, 0.3);
    `}

  ${p =>
    p.type == 'header' &&
    css`
      // pointer-events: none;
      background: #f2f2f2;

      &:hover {
        background: #f2f2f2;
      }

      ${Row.Cell} {
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
        padding-top: 15px;
        padding-bottom: 15px;
        border-bottom: 4px solid #fbdf83;
      }
    `}
`

Row.Cell = styled.div`
  display: table-cell;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  padding: 23px 20px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
  position: relative;
  transition: 0.3s;
  min-width: 100px;

  &:not(:last-child) {
    border-right: 1px solid #f0f0f0;
  }

  @media (max-width: 991px) {
    min-width: 120px;
    padding: 15px 20px;
  }

  ${p =>
    p.button &&
    css`
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    `}
  ${p =>
    p.disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`
